module.exports = __webpack_public_path__ + "img/task-checked.3d53bf8b.svg";